import React, { useContext } from 'react';
// import SecondsTab from './components/SecondsTab/SecondsTab';
import MinutesTab from './components/MinutesTab/MinutesTab';
import HoursTab from './components/HoursTab/HoursTab';
import DayTab from './components/DayTab/DayTab';
import MonthTab from './components/MonthTab/MonthTab';
// import YearTab from './components/YearTab/YearTab';
import { CronGeneratorContext, ICronGeneratorContext } from '../../../../cronGeneratorState/cronGeneratorContext';

const Tabs: React.FC = () => {
	const { visibleForm } = useContext<ICronGeneratorContext>(CronGeneratorContext);

	return (
		<>
			{/*<SecondsTab isVisible={visibleForm === 'seconds'} />*/}
			<MinutesTab isVisible={visibleForm === 'minutes'} />
			<HoursTab isVisible={visibleForm === 'hours'} />
			<DayTab isVisible={visibleForm === 'day'} />
			<MonthTab isVisible={visibleForm === 'month'} />
			{/*<YearTab isVisible={visibleForm === 'year'} />*/}
		</>
	);
};

export default Tabs;
